<template>
  <v-container fluid>
    <page-title>
      Scheduled Tasks
      <template v-slot:buttons>
        <v-btn :to="{name: 'vv.import.wizard'}"
               color="primary">
          New Task
        </v-btn>
        <v-btn v-if="user && user.is_employee"
               :to="{name: 'vv.admin'}"
               class="ml-2">
          Admin
        </v-btn>
      </template>
    </page-title>

    <v-card>
      <v-data-table dense
                    :loading="loading"
                    :headers="headers"
                    :items="tasks"
                    :options.sync="options"
                    :server-items-length="totalTasks"
                    :footer-props="{'items-per-page-options': [50, 100, 500]}">
        <template v-slot:item.name="{item: task}">
          <router-link :to="{name: 'vv.task.show', params: {taskID: task.id}}">
            {{ task.name }}
          </router-link>
        </template>
        <template v-slot:item.import_all="{item: task}">
          {{ task.import_all ? 'Yes' : 'No' }}
        </template>
        <template v-slot:item.documents_count="{item: task}">
          {{ task.import_all ? 'All' : task.documents_count }}
        </template>
        <template v-slot:item.created_at="{item: task}">
          {{ task.created_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
        <template v-slot:item.updated_at="{item: task}">
          {{ task.updated_at | datetime('YYYY-MM-DD h:mm a') }}
        </template>
        <template v-slot:item.actions="{item: task}">
          <v-btn icon
                 @click.prevent="runTask(task)">
            <v-icon color="green">
              fal fa-play-circle
            </v-icon>
          </v-btn>
          <v-btn icon
                 @click.prevent="deleteTask(task)">
            <v-icon color="error">
              fal fa-trash
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import veevaVaultService from '../../../services/veevaVaultService';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      loading: false,
      meta: null,
      options: {
        itemsPerPage: 50,
        page: 1,
        sortBy: [
          'created_at'
        ],
        sortDesc: [
          true
        ],
      },
      totalTasks: 0,
      tasks: [],
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    headers() {
      return [
        {value: 'name', text: 'Name'},
        {value: 'connection.name', text: 'Connection', sortable: false,},
        {value: 'import_all', text: 'Auto-Import', sortable: false},
        {value: 'documents_count', text: 'Documents', sortable: false},
        {value: 'status', text: 'Status'},
        {value: 'created_at', text: 'Created', cellClass: 'text-nowrap'},
        {value: 'updated_at', text: 'Updated', cellClass: 'text-nowrap'},
        {value: 'actions', text: '', sortable: false},
      ]
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      }
    }
  },
  created() {
    //this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.loading) {
        console.log('Already loading, slow down.');
        return;
      }
      console.log('fetchData', this.options.page, this.options.itemsPerPage, this.options);
      this.loading = true;
      const form = {
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        sortBy: this.options.sortBy,
        sortDesc: this.options.sortDesc,
      }
      veevaVaultService.searchTasks(form)
        .then(data => {
          this.tasks = data.data;
          this.meta = data.meta;
          this.totalTasks = this.meta.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    runTask(task) {
      veevaVaultService.runTask(task.id)
        .then(() => {
          this.fetchData();
        })
    },
    deleteTask(task) {
      veevaVaultService.deleteTask(task.id)
        .then(() => {
          this.fetchData();
        });
    }
  }
}
</script>
